import React, { FunctionComponent } from "react";
import {
    Card,
    CardContentArea
} from "@episerver/ui-framework";

import "./demo-unavailable.scss";

interface DemoUnavailableProps {
    componentName?: string;
}

export const DemoUnavailable: FunctionComponent<DemoUnavailableProps> = ({
    componentName
}) => {
    return (
        <Card className="epi-demo-unavailable">
            <CardContentArea>Do you need to use {componentName ? componentName : "this component"}? Please <a href="https://stash.ep.se/projects/UI/repos/design-system/browse/GUIDELINES.md" target="_blank" rel="noopener noreferrer">help implement it and contribute it back</a> to the Design System for others to use.</CardContentArea>
        </Card>
    );
};
